"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVFormInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _AVFormInput = require("./AVFormInput.styled");
var AVFormInput = exports.AVFormInput = function AVFormInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    inputTestId = _ref.inputTestId,
    id = _ref.id,
    invalid = _ref.invalid,
    errorMessage = _ref.errorMessage;
  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    return onChange(target.value);
  };
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_AVFormInput.StyledTextInput, {
    id: id,
    type: "text",
    name: "source_title",
    "data-testid": inputTestId,
    value: value,
    invalid: invalid,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }), invalid && _react["default"].createElement(_AVFormInput.FeedBack, {
    "data-testId": 'error-feedback'
  }, errorMessage));
};
AVFormInput.propTypes = {
  presenterTitle: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  inputTestId: _propTypes.string,
  invalid: _propTypes.bool,
  errorMessage: _propTypes.string,
  id: _propTypes.string
};